import React, { useState, useEffect } from 'react';

const ShippingTwo = () => {
    const [shippingData, setShippingData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchShippingData();
    }, []);

    const fetchShippingData = async () => {
        try {
            console.log('Fetching shipping policy from API...');
            const response = await fetch(`${process.env.REACT_APP_API_URL}/shipping-policy/`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });
            
            console.log('Response status:', response.status);
            
            if (!response.ok) {
                throw new Error(`Failed to fetch shipping policy: ${response.status}`);
            }
            
            const data = await response.json();
            console.log('Fetched shipping policy:', data);
            
            setShippingData(data);
            setLoading(false);
        } catch (err) {
            console.error('Error fetching shipping data:', err);
            setError('Failed to load shipping information');
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <section className="shipping mb-80" id="shipping">
                <div className="shipping-wrapper">
                    <div className="container container-lg">
                        <div className="text-center py-5">
                            <p>Loading shipping information...</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (error) {
        return (
            <section className="shipping mb-80" id="shipping">
                <div className="shipping-wrapper">
                    <div className="container container-lg">
                        <div className="alert alert-danger" style={{ textAlign: 'center', color: 'red' }}>
                            {error}
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (!shippingData) {
        return (
            <section className="shipping mb-80" id="shipping">
                <div className="shipping-wrapper">
                    <div className="container container-lg">
                        <div className="text-center py-5">
                            <p>No shipping information available.</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    const { shipping_page, turn_time, shipping_method, order_tracking, faq_section, need_help } = shippingData;

    return (
        <section className="shipping mb-80" id="shipping">
            <div className="shipping-wrapper">
                <div className="container container-lg">
                    {/* Page Header */}
                    {shipping_page && (
                        <div className="mb-40">
                            <h1 className="mb-16">{shipping_page.page_title}</h1>
                            {shipping_page.process_heading && (
                                <h3 className="mb-8">{shipping_page.process_heading}</h3>
                            )}
                            {shipping_page.content && (
                                <div 
                                    className="content-html"
                                    dangerouslySetInnerHTML={{ __html: shipping_page.content }}
                                />
                            )}
                        </div>
                    )}

                    {/* Standard Turn Time */}
                    {turn_time && turn_time.is_active && (
                        <div className="mb-32">
                            <h3 className="mb-8">{turn_time.heading}</h3>
                            <div 
                                className="content-html"
                                dangerouslySetInnerHTML={{ __html: turn_time.content }}
                            />
                        </div>
                    )}

                    {/* Shipping Methods */}
                    {shipping_method && shipping_method.is_active && (
                        <div className="mb-32">
                            <h3 className="mb-8">{shipping_method.heading}</h3>
                            <div 
                                className="content-html"
                                dangerouslySetInnerHTML={{ __html: shipping_method.content }}
                            />
                        </div>
                    )}

                    {/* Order Tracking */}
                    {order_tracking && order_tracking.is_active && (
                        <div className="mb-32">
                            <h3 className="mb-8">{order_tracking.heading}</h3>
                            <div 
                                className="content-html"
                                dangerouslySetInnerHTML={{ __html: order_tracking.content }}
                            />
                        </div>
                    )}

                    {/* FAQ Section */}
                    {faq_section && faq_section.is_active && (
                        <div className="mb-32">
                            <h3 className="mb-8">{faq_section.heading}</h3>
                            {faq_section.subheading && (
                                <p className="mb-8"><b>{faq_section.subheading}</b></p>
                            )}
                            <div 
                                className="content-html"
                                dangerouslySetInnerHTML={{ __html: faq_section.content }}
                            />
                        </div>
                    )}

                    {/* Need Help Section */}
                    {need_help && need_help.is_active && (
                        <div className="mb-40">
                            <h3 className="mb-8">{need_help.heading}</h3>
                            <div 
                                className="content-html"
                                dangerouslySetInnerHTML={{ __html: need_help.content }}
                            />
                            {need_help.email && (
                                <p>
                                    Contact us at <b><a href={`mailto:${need_help.email}`}>{need_help.email}</a></b>. We're here to help!
                                </p>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ShippingTwo;
